import { addDays, format } from 'date-fns'
import moment from 'moment'
import { bool, func, instanceOf, string } from 'prop-types'
import { kuiperClassNames } from '../../../utils'
import DatePickerPopover from '../Popover'
import DatePickerPopoverV2 from '../PopoverV2'

import './styles.scss'

const renderDatePickerPopover = (
  dateFormat,
  date,
  onChangeDate,
  ariaLabelledBy,
  v2Popover,
  dateRestriction
) => {
  if (v2Popover) {
    if (!dateFormat) dateFormat = 'MMMM d, yyyy'

    return (
      <div className={kuiperClassNames('date')}>
        <DatePickerPopoverV2
          ariaLabelledBy={ariaLabelledBy}
          allowableDates={dateRestriction}
          classNames={kuiperClassNames('date-picker-v2')}
          date={date}
          dateFormat={dateFormat}
          displayType="input"
          focusable={true}
          onSelect={onChangeDate}
          text={date ? format(date, dateFormat) : '—'}
        />
      </div>
    )
  }

  if (!dateFormat) dateFormat = 'LL'
  return (
    <div className={kuiperClassNames('date')}>
      <DatePickerPopover
        ariaLabelledBy={ariaLabelledBy}
        allowableDates={dateRestriction}
        classNames={kuiperClassNames('date-picker')}
        date={moment(date)}
        dateFormat={dateFormat}
        icon="gem-calendar"
        input={true}
        onChangeDate={onChangeDate}
      />
    </div>
  )
}

/**
 * Render a pair of date picker inputs.
 *
 * `startDate` defaults to today; `endDate` defaults to tomorrow.
 */
const DateRangePicker = ({
  // @note For now this has to be a moment.js format string, not a date-fns
  //   format string.
  ariaLabelledBy,
  dateFormat,
  startDate = new Date(),
  endDate = addDays(new Date(), 1),
  onChangeStartDate,
  onChangeEndDate,
  v2Popover = false,
}) => (
  <div className={kuiperClassNames('date-range-picker')}>
    {renderDatePickerPopover(
      dateFormat,
      startDate,
      onChangeStartDate,
      ariaLabelledBy,
      v2Popover,
      {
        end: moment(endDate),
      }
    )}
    <span className={kuiperClassNames('date-separator')}>to</span>
    {renderDatePickerPopover(
      dateFormat,
      endDate,
      onChangeEndDate,
      ariaLabelledBy,
      v2Popover,
      {
        start: moment(startDate),
      }
    )}
  </div>
)
DateRangePicker.displayName = 'Kuiper: DateRangePicker ← DatePicker ← Inputs'

DateRangePicker.propTypes = {
  ariaLabelledBy: string,
  dateFormat: string,
  endDate: instanceOf(Date),
  onChangeEndDate: func,
  onChangeStartDate: func,
  startDate: instanceOf(Date),
  v2Popover: bool,
}

export default DateRangePicker
